import {
  createContext,
  useContext,
  useState,
  type Dispatch,
  type ReactNode,
  type SetStateAction,
} from 'react';
import { createPortal } from 'react-dom';

const SetSlotContext = createContext<Dispatch<SetStateAction<HTMLElement | null>> | null>(null);
const SlotContext = createContext<HTMLElement | null>(null);
const HasProviderContext = createContext(false);

/** Hosts the command strip so pages can portal into the top rail. */
export function SpatialCommandSlotProvider({ children }: { children: ReactNode }) {
  const [slot, setSlot] = useState<HTMLElement | null>(null);
  return (
    <HasProviderContext.Provider value={true}>
      <SetSlotContext.Provider value={setSlot}>
        <SlotContext.Provider value={slot}>{children}</SlotContext.Provider>
      </SetSlotContext.Provider>
    </HasProviderContext.Provider>
  );
}

export function SpatialCommandSlot() {
  const setSlot = useContext(SetSlotContext);
  return <div className="spatial-top-rail-command" ref={setSlot} />;
}

/** Renders in the top rail when the shell provided a slot; otherwise stays in place (tests). */
export function SpatialCommandPortal({ children }: { children: ReactNode }) {
  const hasProvider = useContext(HasProviderContext);
  const slot = useContext(SlotContext);
  if (hasProvider) {
    if (!slot) return null;
    return createPortal(children, slot);
  }
  return <>{children}</>;
}
